import { useMutation } from '@tanstack/react-query';
import { api } from 'src/services';

export type SyncEncounterPractitionerParams = {
  org_uuid: string;
  fhirEncounterId: string;
};

export type SyncEncounterPractitionerResponse = {
  message: string;
  practitioner: {
    id: number;
    first_name: string;
    last_name: string;
    ehr_id: string;
  };
};

export const syncEncounterPractitioner = async (
  params: SyncEncounterPractitionerParams
): Promise<SyncEncounterPractitionerResponse> => {
  const response = await api.get<SyncEncounterPractitionerResponse>(
    '/v2/practitioners/sync_encounter',
    { params }
  );
  return response.data;
};

export const useSyncEncounterPractitioner = () => {
  return useMutation({
    mutationKey: ['syncEncounterPractitioner'],
    mutationFn: (params: SyncEncounterPractitionerParams) =>
      syncEncounterPractitioner(params),
  });
};
